module.exports = __webpack_public_path__ + "img/manifestacion.bdbb02fa.jpg";